module.exports = __webpack_public_path__ + "media/images/gallery/rn_tab_off-2b86780ba71ccebda2c0be6c216b5b3e.jpg";